import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { LoginService } from "../login/shared/login.service";
import { DataService } from '../user-detail.service';
import { StaffService } from '../shared/services/staff.service';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.css']
})
export class AuthenticateComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private staffService: StaffService,
    private dataService: DataService) { }

  ngOnInit() {
    let token = this.activatedRoute.snapshot.queryParamMap.get("token");
    let currentUser = this.loginService.decodeToken(token)
 
    localStorage.setItem('access_token', token);

    this.staffService.getStaffEmploymentType(currentUser._id).subscribe((result => {
      this.dataService.setStaffInfo = result.data;
    }))
    // emit event to show the header
    // this.loginService.loginSuccessful.emit();

    this.router.navigate(['/']);
  }

}
